module.exports = __webpack_public_path__ + "static/media/view1.fedc6403.jpg";